export const PERMS = {
    READ: 'cost_types.read',
    UPDATE: 'cost_types.update',
    DELETE: 'cost_types.delete',
    CREATE: 'cost_types.create',
}
